import {Badge} from "react-bootstrap";
import {DisplayRssi} from "../icons/DisplayRssi";
import {ABOverlayTooltip} from "../../_components/CustomOverlayTooltip";
import React from "react";
import {WhiteCard} from "../_components/WhiteCard";
import {ProjectMap} from "../../../utils2/maps";
import {useTopicSSE} from "../../../hooks/useTopicSSE";
import {SseTopics} from "../../../context/SSEContext";

export function ConnectionSection({device}) {
    const connection = ProjectMap.find(d => d.project === device?.device_project)?.connection

    return <>
        {"wifi" === connection && <WhiteCard className="flex-fill"><WifiConnection/></WhiteCard>}
        {"ethernet" === connection && <WhiteCard className="flex-fill"><EthernetConnection/></WhiteCard>}
    </>
}

function WifiConnection() {
    const AuthMap = ["Undef", "OPEN", "WEP", "WPA/WPA2", "WPA2", "WPA2/WPA3", "WPA3", "WPA/WPA2 Enterprise", "WPA2 Enterprise", "WPA2/WPA3 Enterprise", "WPA3 Enterprise"]

    const online = useTopicSSE(SseTopics.Online)
    const rssi = useTopicSSE(SseTopics.RSSI)
    const wifi = useTopicSSE(SseTopics.WiFi)
    const net = useTopicSSE(SseTopics.Network)

    return <div>
        <div className="mb-2">
            <Badge bg={online ? "info" : "secondary"}>
                <div className="d-flex align-items-center gap-2 mb-">
                    {online ? <>WIFI <DisplayRssi rssi={rssi?.rssi} lock={wifi?.auth}/></>
                        : <>WIFI <i className="bi bi-wifi-off fs-5"/></>}</div>
            </Badge>
        </div>
        {online ?
            <ABOverlayTooltip placement="right" tip={<SsidTip rssi={rssi?.rssi} auth={AuthMap[wifi?.auth]} ch={wifi?.ch}/>}>
                <span>{wifi?.ssid}</span>
            </ABOverlayTooltip> :
            "SSID"
        }
        <div>{online ?
            <a href={"http://" + net?.ipv4} target="_blank"
               className="link-underline link-underline-opacity-0 link-underline-opacity-75-hover link-offset-1 link-offset-1-hover">{net?.ipv4}</a>
            : "IPv4"}
        </div>

    </div>
}

function SsidTip({rssi, auth, ch}) {
    return <>
        <div>RSSI: {rssi}</div>
        <div>AUTH: {auth}</div>
        <div>Channel: {ch}</div>
    </>
}

function EthernetConnection() {
    const online = useTopicSSE(SseTopics.Online)
    const net = useTopicSSE(SseTopics.Network)

    return <div>
        <div className="mb-2">
            <Badge bg={online ? "info" : "secondary"}>
                <div className="d-flex align-items-center gap-2 mb-">LAN <i className="bi bi-ethernet fs-5"/></div>
            </Badge>
        </div>
        <div>10/100 Mbps</div>
        <div>{online ?
            <a href={"http://" + net?.ipv4} target="_blank"
               className="link-underline link-underline-opacity-0 link-underline-opacity-75-hover link-offset-1 link-offset-1-hover">{net?.ipv4}</a>
            : "IPv4"}
        </div>

    </div>
}